import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { CalendarOff, Trash2 } from "lucide-react";
import api from "../../api";

const HOURS = [9, 10, 11, 12, 13, 14, 15, 16, 17];

export default function ScheduleBlocksCard() {
  const [items, setItems] = useState([]);
  const [date, setDate] = useState("");
  const [hours, setHours] = useState([]);
  const [reason, setReason] = useState("");
  const [buffer, setBuffer] = useState("");
  const load = () => api.get("/admin/blocks").then(r => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); api.get("/admin/settings/schedule").then(r => setBuffer(String(r.data.buffer_min))).catch(() => {}); }, []);
  const saveBuffer = async () => {
    try { await api.put("/admin/settings/schedule", { buffer_min: Number(buffer) }); toast.success("Intervalo atualizado"); }
    catch (e) { toast.error(e.response?.data?.detail || "Valor inválido"); }
  };

  const toggle = (h) => setHours(s => s.includes(h) ? s.filter(x => x !== h) : [...s, h]);
  const save = async () => {
    if (!date) return toast.error("Escolha o dia");
    await api.post("/admin/blocks", { date, hours, reason });
    toast.success(hours.length ? "Horários bloqueados" : "Dia inteiro bloqueado");
    setDate(""); setHours([]); setReason(""); load();
  };
  const del = async (id) => { await api.delete(`/admin/blocks/${id}`); toast.success("Bloqueio removido"); load(); };

  return (
    <div className="card-arya p-5 mb-4" data-testid="schedule-blocks-card">
      <div className="flex items-center gap-2 mb-3"><CalendarOff size={16} className="text-[color:var(--danger)]"/><h3 className="font-serif text-xl">Feriados e folgas</h3>
        <div className="ml-auto flex items-center gap-2 text-xs" data-testid="buffer-setting">
          <span className="text-[color:var(--ink-500)]">Intervalo entre atendimentos</span>
          <input type="number" min="0" max="120" value={buffer} onChange={e=>setBuffer(e.target.value)} className="w-16 rounded-lg border border-[var(--line)] bg-white px-2 py-1 text-sm" data-testid="buffer-input"/>
          <span>min</span>
          <button onClick={saveBuffer} className="btn-ghost !py-1 !px-3 text-xs" data-testid="buffer-save">Salvar</button>
        </div>
      </div>
      <div className="flex flex-wrap items-end gap-3">
        <input type="date" value={date} onChange={e=>setDate(e.target.value)} className="rounded-xl border border-[var(--line)] bg-white px-3 py-2 text-sm" data-testid="block-date"/>
        <input value={reason} onChange={e=>setReason(e.target.value)} placeholder="Motivo (opcional)" className="rounded-xl border border-[var(--line)] bg-white px-3 py-2 text-sm flex-1 min-w-[160px]" data-testid="block-reason"/>
        <button onClick={save} className="btn-gold !py-2 !px-4 text-sm" data-testid="block-save">{hours.length ? `Bloquear ${hours.length} horário(s)` : "Bloquear dia inteiro"}</button>
      </div>
      <div className="flex flex-wrap gap-2 mt-3" data-testid="block-hours">
        <span className="text-xs text-[color:var(--ink-500)] self-center">Só alguns horários?</span>
        {HOURS.map(h => (
          <button key={h} onClick={()=>toggle(h)} aria-pressed={hours.includes(h)} className="slot-chip !py-1 !px-3 text-xs" data-testid={`block-hour-${h}`}>{h}h</button>
        ))}
      </div>
      {items.length > 0 && (
        <ul className="divide-y divide-[var(--line)] mt-4 text-sm">
          {items.map(b => (
            <li key={b.block_id} className="py-2 flex items-center justify-between gap-3" data-testid={`block-${b.block_id}`}>
              <span><b>{b.date.split("-").reverse().join("/")}</b> · {b.hours?.length ? b.hours.map(h=>`${h}h`).join(", ") : "Dia inteiro"}{b.reason ? ` · ${b.reason}` : ""}</span>
              <button onClick={()=>del(b.block_id)} className="p-1.5 text-[color:var(--danger)]" data-testid={`block-del-${b.block_id}`}><Trash2 size={14}/></button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
